import Cookies from 'js-cookie'

// Must match the backend's JWT_EXPIRES_IN (apps/api/src/shared/config/index.ts) —
// otherwise the cookie can outlive or (as before) undercut the token's real lifetime.
export const TOKEN_COOKIE_EXPIRES_DAYS = 7

export function setAuthToken(token: string) {
  Cookies.set('token', token, { expires: TOKEN_COOKIE_EXPIRES_DAYS })
}

export function clearAuthSession() {
  Cookies.remove('token')
  try { localStorage.removeItem('user') } catch {}
}

export function handleSessionExpired(loginPath: string = '/login') {
  clearAuthSession()
  if (window.location.pathname !== loginPath) {
    window.location.replace(loginPath)
  }
}
